var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('app-sales-table',{attrs:{"Course_Type":_vm.CourseType,"Purchase_Type":_vm.PurchaseType,"Status":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }